import { render, staticRenderFns } from "./EventStepNav.vue?vue&type=template&id=5b162386&scoped=true"
import script from "./EventStepNav.vue?vue&type=script&lang=js"
export * from "./EventStepNav.vue?vue&type=script&lang=js"
import style0 from "./EventStepNav.vue?vue&type=style&index=0&id=5b162386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b162386",
  null
  
)

export default component.exports